import { CxEvent } from '@spartacus/core';

export class GtmGgProductPageEvent extends CxEvent {
  event?: string;
  ecommerce?: {
    detail?: {
      actionField?: {};
      products?: {
        name?: string;
        price?: string;
        category?: string;
        id?: string;
        variant?: string;
        brand?: string;
      }[];
    };
  };
}
